const checkValidDate = (date) => {
    const dateValue = new Date(date);
    if ((dateValue !== "Invalid Date") && !isNaN(dateValue)) {
        return dateValue;
    }
    return false;
}

const checkEqualDate = (fromDate, toDate) => {
    if (fromDate.getTime() === toDate.getTime()) {
        return true;
    }
    return false;
}

const checkGreaterDate = (fromDate, toDate) => {
    if (fromDate.getTime() > toDate.getTime()) {
        return true;
    }
    return false;
}

const checkLessDate = (fromDate, toDate) => {
    if (fromDate.getTime() < toDate.getTime()) {
        return true;
    }
    return false;
}

export { checkValidDate, checkEqualDate, checkGreaterDate, checkLessDate };


// WEBPACK FOOTER //
// ./src/components/Helpers/Dates/CompareDate.js